export const orderDetails = {
  orderId: 'Commande n°',
  orderNumber: 'Numéro de commande',
  purchaseOrderNumber: 'Numéro de bon de commande',
  methodOfPayment: 'Mode de paiement',
  shippingMethod: 'Mode de livraison',
  replenishmentId: 'Réapprovisionnement n°',
  purchaseOrderId: 'Bon de commande n°',
  emptyPurchaseOrderId: 'Aucun',
  none: 'Aucun {{value}}',
  placed: 'Passée',
  placedBy: 'Passée par',
  unit: 'Unité',
  costCenter: 'Centre de coûts',
  costCenterAndUnit: 'Centre de coûts / Unité',
  costCenterAndUnitValue: '{{costCenterName}} / {{unitName}}',
  payByAccount: 'Payer par compte',
  placedOn: 'Date de création de la commande',
  paidByCreditCard: '(payé par carte de crédit)',
  status: 'Statut',
  shippedOn: 'Expédié le',
  startOn: 'Débuter le',
  nextOrderDate: 'Date de la prochaine commande',
  frequency: 'Fréquence',
  cancelled: ' Annulée',
  deliveryStatus_IN_TRANSIT: 'En transit',
  deliveryStatus_READY_FOR_PICKUP: 'Prêt pour la cueillette',
  deliveryStatus_READY_FOR_SHIPPING: 'Prêt pour l\'expédition',
  deliveryStatus_WAITING: 'En attente',
  deliveryStatus_DELIVERING: 'En livraison',
  deliveryStatus_PICKPACK: 'En préparation pour l\'expédition',
  deliveryStatus_PICKUP_COMPLETE: 'Cueillette complétée',
  deliveryStatus_DELIVERY_COMPLETED: 'Livraison complétée',
  deliveryStatus_PAYMENT_NOT_CAPTURED: 'Problème de paiement',
  deliveryStatus_READY: 'En traitement',
  deliveryStatus_DELIVERY_REJECTED: 'Livraison refusée',
  deliveryStatus_SHIPPED: 'Expédiée',
  deliveryStatus_TAX_NOT_COMMITTED: 'Problème de taxe',
  deliveryStatus_CANCELLED: 'Annulée',
  statusDisplay_cancelled: 'Annulée',
  statusDisplay_cancelling: 'Annulation en cours',
  statusDisplay_completed: 'Complétée',
  statusDisplay_created: 'Créée',
  statusDisplay_error: 'En attente',
  statusDisplay_Error: 'En attente',
  statusDisplay_undefined: '',
  statusDisplay_processing: 'En attente',
  statusDisplay_open: 'Ouverte',
  statusDisplay_pending: {
    approval: 'Approbation en attente',
    merchant: {
      approval: 'Approbation du marchand en attente',
    },
  },
  statusDisplay_approved: 'Approuvée',
  statusDisplay_rejected: 'Refusée',
  statusDisplay_merchant: {
    approved: 'Approuvée par le marchand',
    rejected: 'Refusée par le marchand',
  },
  statusDisplay_assigned: {
    admin: 'Assignée à l\'administrateur',
  },
  consignmentTracking: {
    action: 'Suivre le colis',
    dialog: {
      header: 'Informations de suivi',
      shipped: 'Expédié',
      estimate: 'Livraison estimée',
      carrier: 'Service de livraison',
      trackingId: 'Numéro de suivi',
      noTracking:
        'Le colis n\'a pas encore quitté l\'entrepôt. Les informations de suivi seront disponibles après l\'expédition.',
      loadingHeader: 'Suivi de l\'envoi',
    },
  },
  cancellationAndReturn: {
    returnAction: 'Demander un retour',
    cancelAction: 'Annuler des articles',
    item: 'Article',
    itemPrice: 'Prix de l\'article',
    quantity: 'Quantité maximale',
    returnQty: 'Quantité à retourner',
    cancelQty: 'Quantité à annuler',
    setAll: 'Définir toutes les quantités au maximum',
    totalPrice: 'Total',
    submit: 'Soumettre la demande',
    returnSuccess: 'Votre demande de retour ({{rma}}) a été soumise',
    cancelSuccess: 'Votre demande d\'annulation a été soumise (la commande initiale {{orderCode}} sera mise à jour)',
  },
  cancelReplenishment: {
    title: 'Annuler le réapprovisionnement',
    description: 'Annuler toutes les commandes de réapprovisionnement futures?',
    accept: 'Oui',
    reject: 'Non',
    cancelSuccess: 'La commande de réapprovisionnement n°{{replenishmentOrderCode}} a été annulée avec succès',
  },
};
export const orderHistory = {
  orderHistory: 'Historique des commandes',
  orderId: 'Commande n°',
  emptyPurchaseOrderId: 'Aucun',
  date: 'Date',
  status: 'Statut',
  total: 'Total',
  noOrders: 'Aucune commande enregistrée pour ce compte.',
  noReplenishmentOrders: 'Aucune commande de réapprovisionnement enregistrée pour ce compte.',
  startShopping: 'Commencer à magasiner',
  sortByMostRecent: 'Trier par plus récent',
  replenishmentOrderHistory: 'Historique des commandes de réapprovisionnement',
  replenishmentOrderId: 'Réapprovisionnement n°',
  purchaseOrderNumber: 'B.C. n°',
  startOn: 'Débuter le',
  frequency: 'Fréquence',
  nextOrderDate: 'Date de la prochaine commande',
  cancel: 'Annuler',
  cancelled: 'Annulée',
  replenishmentHistory: 'Historique de réapprovisionnement',
  notFound: 'Aucune commande trouvée',
};
export const closeAccount = {
  confirmAccountClosure: 'Confirmer la fermeture du compte',
  confirmAccountClosureMessage: 'Êtes-vous sûr de vouloir fermer votre compte?',
  closeMyAccount: 'Fermer mon compte',
  accountClosedSuccessfully: 'Compte fermé avec succès',
  accountClosedFailure: 'Échec de la fermeture du compte',
};
export const updateEmailForm = {
  newEmailAddress: {
    label: 'Nouvelle adresse courriel',
    placeholder: 'Entrer le courriel',
  },
  confirmNewEmailAddress: {
    label: 'Confirmer la nouvelle adresse courriel',
    placeholder: 'Entrer le courriel',
  },
  enterValidEmail: 'Veuillez saisir un courriel valide.',
  bothEmailMustMatch: 'Les deux courriels doivent être identiques',
  password: {
    label: 'Mot de passe',
    placeholder: 'Entrer le mot de passe',
  },
  pleaseInputPassword: 'Veuillez saisir votre mot de passe',
  emailUpdateSuccess: 'Succès. Veuillez vous connecter avec {{ newUid }}',
};
export const updatePasswordForm = {
  oldPassword: {
    label: 'Ancien mot de passe',
    placeholder: 'Ancien mot de passe',
  },
  oldPasswordIsRequired: 'L\'ancien mot de passe est obligatoire.',
  newPassword: {
    label: 'Nouveau mot de passe',
    placeholder: 'Nouveau mot de passe',
  },
  passwordMinRequirements: 'Le mot de passe doit comporter au moins six caractères, dont une lettre majuscule, un chiffre et un symbole',
  confirmPassword: {
    label: 'Confirmer le nouveau mot de passe',
    placeholder: 'Confirmer le mot de passe',
  },
  bothPasswordMustMatch: 'Les deux mots de passe doivent être identiques',
  passwordUpdateSuccess: 'Mot de passe mis à jour avec succès',
  passwordHistoryError: 'Le mot de passe n\'est pas valide. Veuillez utiliser un mot de passe différent de ceux déjà utilisés.',
};
export const updateProfileForm = {
  title: 'Titre',
  none: '',
  firstName: {
    label: 'Prénom',
    placeholder: 'Prénom',
  },
  firstNameIsRequired: 'Le prénom est obligatoire.',
  lastName: {
    label: 'Nom de famille',
    placeholder: 'Nom de famille',
  },
  lastNameIsRequired: 'Le nom de famille est obligatoire.',
  profileUpdateSuccess: 'Renseignements personnels mis à jour avec succès',
  customerId: 'Client n°',
};
export const consentManagementForm = {
  clearAll: 'Tout effacer',
  selectAll: 'Tout sélectionner',
  message: {
    success: {
      given: 'Consentement accordé avec succès.',
      withdrawn: 'Consentement retiré avec succès.',
    },
  },
};
export const myCoupons = {
  noCouponsMessage: 'Vous n\'avez aucun coupon disponible.',
  effectiveTitle: 'En vigueur :',
  Effective: 'En vigueur',
  PreSession: 'Bientôt en vigueur',
  ExpireSoon: 'Expire bientôt',
  readMore: 'En savoir plus',
  notification: 'Notification',
  findProducts: 'Trouver des produits',
  status: 'Statut :',
  dialogTitle: 'Coupon',
  claimCustomerCoupon: 'Vous avez réclamé ce coupon avec succès.',
  myCoupons: 'Mes coupons',
  startDateAsc: 'Date de début (croissant)',
  startDateDesc: 'Date de début (décroissant)',
  endDateAsc: 'Date de fin (croissant)',
  endDateDesc: 'Date de fin (décroissant)',
  sortByMostRecent: 'Trier par plus récent',
  notesPreffix: 'Vous pouvez définir vos canaux de notification préférés pour les coupons sur la page ',
  notesLink: 'Canaux de notification',
  notesSuffix: '.',
};
export const notificationPreference = {
  message: 'Sélectionnez vos canaux de notification préférés',
  note: 'Remarque : ',
  noteMessage: 'Si vous désactivez tous les canaux, vous ne recevrez plus aucune notification.',
  EMAIL: 'Courriel :',
  SMS: 'SMS :',
  SITE_MESSAGE: 'Message du site',
};
export const myInterests = {
  header: 'Mes intérêts',
  item: 'Article',
  price: 'Prix',
  notifications: 'Notifications',
  noInterests: 'Vous n\'avez aucun intérêt enregistré pour le moment.',
  inStock: 'En stock',
  lowStock: 'Stock faible',
  outOfStock: 'En rupture de stock',
  BACK_IN_STOCK: 'De nouveau en stock',
  sortByMostRecent: 'Trier par plus récent',
  expirationDate: ' - Jusqu\'au {{ expirationDate }}',
  productId: 'ID {{ code }}',
  remove: 'SUPPRIMER',
  sorting: {
    byNameAsc: 'Nom (croissant)',
    byNameDesc: 'Nom (décroissant)',
  },
};
export const AccountOrderHistoryTabContainer = {
  tabs: {
    AccountOrderHistoryComponent: 'TOUTES LES COMMANDES ({{param}})',
    OrderReturnRequestListComponent: 'RETOURS ({{param}})',
  },
};
export const returnRequestList = {
  returnRequestId: 'Retour n°',
  orderId: 'Commande n°',
  date: 'Date de création',
  status: 'Statut',
  sortByMostRecent: 'Trier par plus récent',
  statusDisplay_APPROVAL_PENDING: 'Approbation en attente',
  statusDisplay_CANCELED: 'Annulée',
  statusDisplay_CANCELLING: 'Annulation en cours',
  statusDisplay_WAIT: 'En attente',
  statusDisplay_RECEIVED: 'Reçue',
  statusDisplay_RECEIVING: 'Réception en cours',
  statusDisplay_APPROVING: 'Approbation en cours',
  statusDisplay_REVERSING_PAYMENT: 'Remboursement en cours',
  statusDisplay_PAYMENT_REVERSED: 'Paiement remboursé',
  statusDisplay_PAYMENT_REVERSAL_FAILED: 'Échec du remboursement',
  statusDisplay_REVERSING_TAX: 'Remboursement de taxe en cours',
  statusDisplay_TAX_REVERSED: 'Taxe remboursée',
  statusDisplay_TAX_REVERSAL_FAILED: 'Échec du remboursement de taxe',
  statusDisplay_COMPLETED: 'Complétée',
};
export const returnRequest = {
  returnRequestId: 'Demande de retour n°',
  orderCode: 'Pour la commande n°',
  status: 'Statut du retour',
  cancel: 'Annuler la demande de retour',
  item: 'Description',
  itemPrice: 'Prix de l\'article',
  returnQty: 'Quantité à retourner',
  total: 'Total',
  summary: 'Totaux du retour',
  subtotal: 'Sous-total',
  deliveryCode: 'Frais de livraison',
  estimatedRefund: 'Remboursement estimé',
  note: 'Les totaux sont estimés et peuvent ne pas inclure les taxes applicables ou autres frais.',
  cancelSuccess: 'Votre demande de retour ({{rma}}) a été annulée',
};
export const wishlist = {
  empty: 'Aucun produit dans votre liste de souhaits',
};

export const myAccount = {
  orderDetails,
  orderHistory,
  closeAccount,
  updateEmailForm,
  updatePasswordForm,
  updateProfileForm,
  consentManagementForm,
  myCoupons,
  wishlist,
  notificationPreference,
  myInterests,
  AccountOrderHistoryTabContainer,
  returnRequestList,
  returnRequest,
};
